import { render, staticRenderFns } from "./OrderCartWrapper.vue?vue&type=template&id=ed727188&"
import script from "./OrderCartWrapper.vue?vue&type=script&lang=js&"
export * from "./OrderCartWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports